import { useEffect, useState } from 'react';
import { chamarAssistente } from './utils';
import type { ResumoResposta } from './types';

export type EstadoResumo = 'carregando' | 'pronto' | 'sem-resumo';

// Pede o resumo do dia para a mesma função de borda do chat, uma vez por abertura.
// Se falhar, o cartão simplesmente não aparece (o chat continua funcionando).
export function useResumoAgente(eventoId: number, ativo: boolean) {
  const [dados, setDados] = useState<ResumoResposta | null>(null);
  const [estado, setEstado] = useState<EstadoResumo>('carregando');

  useEffect(() => {
    if (!ativo || !Number.isFinite(eventoId)) return;
    let vivo = true;
    setEstado('carregando');
    (async () => {
      try {
        const resp = await chamarAssistente<ResumoResposta>({
          acao: 'resumo',
          evento_id: eventoId,
        });
        if (!vivo) return;
        if (resp && typeof resp.resumo === 'string' && resp.resumo.trim()) {
          setDados(resp);
          setEstado('pronto');
        } else {
          setEstado('sem-resumo');
        }
      } catch {
        if (vivo) setEstado('sem-resumo');
      }
    })();
    return () => {
      vivo = false;
    };
  }, [ativo, eventoId]);

  return { dados, estado };
}